/**
 * @module Annotation
 * @description Legal Annotation
 */
import { useState, useEffect } from "react";

/**
 * @function Component
 * @description
 */
const Component = ({ hash, content, disclosures }) => {
  const [annotationIndex, setAnnotationIndex] = useState();

  /**
   * @function useEffect
   * @description Kick off this modules functions
   */
  useEffect(() => {
    const legal = [...disclosures].filter(
      (disclosure) => disclosure.hash === hash,
    )[0];

    if (!legal) {
      return;
    }

    setAnnotationIndex(legal.annotationIndex);
  }, [disclosures, hash]);

  return (
    <>
      {content}
      <a
        className="legal-annotation"
        href="#site-legal"
        data-legal-hash={hash}
        aria-describedby={`legal-${annotationIndex}`}
      >
        <span className="screen-reader-text">Legal Annotation</span>{" "}
        {annotationIndex}
      </a>
    </>
  );
};

export default Component;
